<script setup>
import { GoogleMap, Marker, Circle } from 'vue3-google-map';
import { computed } from 'vue';

const props = defineProps({
  latitude: {
    type: Number,
    default: null,
  },
  longitude: {
    type: Number,
    default: null,
  },
  zoom: {
    type: Number,
    default: 14,
  },
  height: {
    type: Number,
    default: 100,
  },
  isStatic: {
    type: Boolean,
    default: true,
  },
  withCircle: {
    type: Boolean,
    default: false,
  },
  withMarker: {
    type: Boolean,
    default: false,
  },
  circleOptions: {
    type: Object,
    default: null,
  },
});

const apiKey = window.GOOGLE_API_KEY;

const center = computed(() => {
  if (props.latitude === null || props.longitude === null) {
    return null;
  }

  return {
    lat: props.latitude,
    lng: props.longitude,
  };
});

const circleOptions = computed(() => ({
  center: center.value,
  radius: 300,
  strokeColor: '#3C46DC',
  strokeOpacity: 1,
  strokeWeight: 2,
  fillColor: '#3C46DC',
  fillOpacity: 0.2,
  clickable: false,
  ...props.circleOptions,
}));

const style = {
  height: `${props.height}px`,
  width: 'auto',
};

const markerOptions = {
  position: center.value,
  icon: {
    url: '/images/ph_map-pin-espace.svg',
  },
};
</script>

<template>
  <GoogleMap
    :api-key="apiKey"
    :center="center"
    :zoom="zoom"
    :style="style"
    :zoom-control="!isStatic"
    :map-type-control="!isStatic"
    :scale-control="!isStatic"
    :street-view-control="!isStatic"
    :rotate-control="!isStatic"
    :fullscreen-control="!isStatic"
    :clickable-icons="!isStatic"
    :disable-default-ui="true"
    gesture-handling="none"
  >
    <Circle
      v-if="withCircle"
      :options="circleOptions"
    />

    <Marker
      v-if="withMarker"
      :options="markerOptions"
    />
  </GoogleMap>
</template>
